import { render } from "./mycourse.vue?vue&type=template&id=1f3e7c48&scoped=true"
import script from "./mycourse.vue?vue&type=script&lang=js"
export * from "./mycourse.vue?vue&type=script&lang=js"

import "./mycourse.vue?vue&type=style&index=0&id=1f3e7c48&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3e7c48"]])

export default __exports__